<template>
  <div
    v-if="review.name && review.rating && review.review"
    class="bg-background-yellow p-4 rounded"
    data-test-id="user-review"
  >
    <div
      class="flex flex-col m:flex-row items-start m:items-center text-midnight font-medium mb-4 m:mb-2 text-base leading-normal font-normal"
    >
      {{ review.name }}

      <rating-stars class="mt-2 m:ml-2 m:mt-0" star-classes="w-3 h-3" :mark="rating" />
    </div>

    <span class="text-dark-grey text-base leading-normal" v-html="review.review" />
  </div>
</template>

<script>
import RatingStars from "@/features/smartbanner/components/rating_stars"

export default {
  name: "UserReview",
  components: {
    RatingStars
  },
  props: {
    review: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    rating() {
      return parseInt(this.review.rating)
    }
  }
}
</script>
